import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { OnboardStudentBody } from "@shared-kernel/application/ports/shared/shared-repository";

export const onboardStudent = createAsyncThunk<void, OnboardStudentBody, { extra: Partial<Dependencies> }>(
  "users/onboardStudent",
  async (body, { extra: { sharedRepository } }) => {
    return sharedRepository!.onboardStudent(body);
  },
);
